import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PromotionLinkService {

  constructor() { }

  cleanPromotionLinkCodeFromSession(sessionStorage) {
    if (sessionStorage.RecordPromotionLink !== undefined || sessionStorage.RecordPromotionLink != null) {
      sessionStorage.RecordPromotionLink = null;
    }
  }

}
